
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employers-get-in-touch",
      function () {
        return require("private-next-pages/employers-get-in-touch/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employers-get-in-touch"])
      });
    }
  